const ClinicalNotesReportTemplate = ({
  notes = [],
  bookingData = {},
  patientRecord = {},
  medicalProfRecord = {},
  clinicRecord = {}
}) => {
  const formatDate = (date) => {
    if (!date) return ''
    const d = new Date(date)
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })
  }

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>Clinical Notes Report</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 20px;
          color: #000;
          background: #fff;
        }
        h1 {
          font-size: 18px;
          margin-bottom: 20px;
        }
        .info-section {
          margin-bottom: 20px;
        }
        .info-item {
          margin-bottom: 5px;
        }
        .notes-section {
          margin-top: 30px;
        }
        .note-item {
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 1px solid #ccc;
        }
        .note-date {
          font-weight: bold;
          margin-bottom: 5px;
        }
        .note-content {
          margin-left: 20px;
        }
      </style>
    </head>
    <body>
      <h1>CLINICAL NOTES REPORT</h1>
      
      <div class="info-section">
        <div class="info-item"><strong>Patient Name:</strong> ${patientRecord.firstName || ''} ${
    patientRecord.lastName || ''
  }</div>
        <div class="info-item"><strong>Patient ID:</strong> ${patientRecord.idNo || patientRecord._id || ''}</div>
        <div class="info-item"><strong>Booking Date:</strong> ${
          bookingData?.bookingDate ? formatDate(bookingData.bookingDate) : ''
        }</div>
      </div>
      
      <div class="notes-section">
        <h2 style="font-size: 16px;">Clinical Notes:</h2>
        ${
          notes.length === 0
            ? '<p>No clinical notes found.</p>'
            : notes
                .map(
                  (note) => `
            <div class="note-item">
              <div class="note-date">${formatDate(note.createdAt)}</div>
              <div class="note-content">${note.content || ''}</div>
            </div>
          `
                )
                .join('')
        }
      </div>
    </body>
    </html>
  `
}

export default ClinicalNotesReportTemplate
